import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import theme from './styles/theme';
import * as Sentry from "@sentry/react";
import { ENV, SENTRY_RELEASE, SENTRY_URL } from "./config/";

declare global {
  interface Window {
    ethereum: any;
    web3: any;
  }
}

if (SENTRY_URL) {
  Sentry.init({
    dsn: SENTRY_URL,
    release: SENTRY_RELEASE,
    environment: ENV
  });
}

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
